import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as Styled from './Controls.styles';
import { setToLocalStorage, getFromLocalStorage } from '../../global/helpers';
import * as actionService from '../../containers/EditPage/actions';
import * as actionOrder from '../../containers/OrdersPage/actions';
import * as constants from '../../containers/ProductsPage/constants';
import { selectors as loginSelectors } from '../../containers/LoginPage/reducer';
import { UserRole } from '../../containers/OrdersPage/types';
import { Chat2Desk } from '../../global/integrations/сhat2Desk';

// Функция для определения типа устройства (desktop/mobile)
const detectDeviceType = (): boolean => {
  const hasTouchScreen =
    'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileDevice =
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      userAgent
    );

  return !hasTouchScreen && !isMobileDevice;
};

const Controls = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const role = getFromLocalStorage('role');
  const dataUser = useSelector(loginSelectors.userData);

  const [isDesktopMode, setIsDesktopMode] = useState(detectDeviceType());

  const [education, setEducation] = useState(
    history.location.pathname.includes('/test-orders') || false
  );

  const [isOpen, setOpen] = useState(false);
  const [chatInitialized, setChatInitialized] = useState(false);

  const getActivePage = (active: string) => {
    return history.location.pathname === active ||
      history.location.pathname.includes(active)
      ? 'active'
      : '';
  };

  const handleChatClick = () => {
    // отправляем актцальную информацию о странице+заказе и открываем чат
    const chat24: any = document.querySelector('#chat24-root chat-24');
    if (chat24 && typeof chat24.sendClientInfo === 'function') {
      const defs = chat24.getCustomFields() ?? [];
      const byName: Record<string, number> = {};
      defs.forEach((f: any) => {
        byName[f.name] = f.id;
      });

      const loyaltyField = history.location.pathname.startsWith('/loyalty')
        ? {
            [byName.loyalty_page]: 'ПЛ',
          }
        : {
            [byName.loyalty_page]: '',
          };
      const emdelField = history.location.pathname.startsWith('/orders/EM')
        ? {
            [byName.emdel_order]: 'Емдел',
          }
        : {
            [byName.emdel_order]: '',
          };
      const lastOrder = history.location.pathname.split('/')[2]
        ? {
            [byName.last_order]: history.location.pathname.split('/')[2],
          }
        : {};
      chat24.sendClientInfo({
        customFields: {
          [byName.current_page]: history.location.pathname,
          ...lastOrder,
          ...loyaltyField,
          ...emdelField,
        },
      });
    }
    document.dispatchEvent(new CustomEvent('popups:open'));
  };

  const handleClick = (push: string) => {
    setOpen(false);
    setToLocalStorage('selectedProduct', null);
    setToLocalStorage(constants.ACTIVE_TAB_KEY, constants.UNATTACHED);
    dispatch(actionService.clearSelectedProduct());
    dispatch(actionOrder.clearSelectedOrder());
    push !== '/orders' && dispatch(actionOrder.clearOrders());
    if (push === '/orders') {
      !education
        ? dispatch(
            actionOrder.getOrders.request({
              status: '',
              limit:
                role === UserRole.OPERATOR ||
                role === UserRole.ADMIN ||
                role === UserRole.HEAD_OPERATOR ||
                role === UserRole.DISPATCHER_B2B
                  ? 200
                  : 100,
              postEffect: () => history.push(push),
            })
          )
        : history.push('/orders');
    } else history.push(push);
  };

  useEffect(() => {
    setIsDesktopMode(detectDeviceType());
  }, []);

  // закрываем чат при переходе на другую страницу
  useEffect(() => {
    if (
      process.env.REACT_APP_CHAT2DESK_API_TOKEN &&
      process.env.REACT_APP_CHAT_ACTIVE === 'true'
    ) {
      document.dispatchEvent(new CustomEvent('popups:close'));
    }
  }, [history?.location?.pathname]);

  useEffect(() => {
    if (
      process.env.REACT_APP_CHAT2DESK_API_TOKEN &&
      process.env.REACT_APP_CHAT_ACTIVE === 'true' &&
      dataUser
    ) {
      dataUser &&
        Chat2Desk(dataUser, history?.location?.pathname, setChatInitialized);
    }
  }, [dataUser]);

  return (
    <>
      {chatInitialized && (
        <Styled.Chat2Desk
          onClick={() => {
            handleChatClick();
          }}
        >
          <img src="/images/ch2d_icon.jpg" alt="icon" />
        </Styled.Chat2Desk>
      )}
      <Styled.ControlsContainer className={`${isDesktopMode ? 'desktop' : ''}`}>
        <Styled.ControlsContentContainer>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '20px',
              padding: '16px',
            }}
          >
            {role === UserRole.ADMIN && (
              <Styled.ControlButtonContainer
                className={`${getActivePage('/sources')}`}
                onClick={() => handleClick('/sources')}
                style={{
                  margin: 0,
                }}
              >
                <img
                  src={
                    getActivePage('/sources')
                      ? '/images/sources-white.svg'
                      : '/images/sources.svg'
                  }
                  alt="icon"
                />
                {t('Header.SOURCES_BTN_TEXT')}
              </Styled.ControlButtonContainer>
            )}
            {role === UserRole.PHARMACIST && (
              <Styled.ControlButtonContainer
                id="test-orders"
                className={`${getActivePage('/test-orders')}`}
                onClick={() => handleClick('/test-orders')}
                style={{
                  margin: 0,
                }}
              >
                <img
                  src={
                    getActivePage('/test-orders')
                      ? '/images/study-white.svg'
                      : '/images/study.svg'
                  }
                  alt="icon"
                />
                {t('Header.STUDY_BTN')}
              </Styled.ControlButtonContainer>
            )}
            {role === UserRole.MANAGER && (
              <Styled.ControlButtonContainer
                id="test-orders"
                className={`${getActivePage('/report')}`}
                onClick={() => handleClick('/report')}
                style={{
                  margin: 0,
                }}
              >
                <img
                  src={
                    getActivePage('/report')
                      ? '/images/report-white.svg'
                      : '/images/report.svg'
                  }
                  alt="icon"
                />
                {t('Header.REPORT_BTN_TEXT')}
              </Styled.ControlButtonContainer>
            )}
            {(role === UserRole.ADMIN ||
              role === UserRole.PHARMACIST ||
              role === UserRole.MANAGER ||
              role === UserRole.OPERATOR ||
              role === UserRole.DISPATCHER_B2B) && (
              <Styled.ControlButtonContainer
                id="orders"
                className={`${getActivePage('/orders')}`}
                onClick={() => handleClick('/orders')}
                style={{
                  margin: 0,
                }}
              >
                <img
                  src={
                    getActivePage('/orders')
                      ? '/images/orders-white.svg'
                      : '/images/orders.svg'
                  }
                  alt="icon"
                />
                {t('Header.ORDER_SEARCH_BTN_TEXT')}
              </Styled.ControlButtonContainer>
            )}
            {(role === UserRole.ADMIN ||
              role === UserRole.PHARMACIST ||
              role === UserRole.MANAGER) && (
              <Styled.ControlButtonContainer
                className={`${getActivePage('/sales')}`}
                onClick={() => handleClick('/sales')}
                style={{
                  margin: 0,
                }}
              >
                {' '}
                <img
                  src={
                    getActivePage('/sales')
                      ? '/images/sales-white.svg'
                      : '/images/sales.svg'
                  }
                  alt="icon"
                />
                {t('Header.SALES')}
              </Styled.ControlButtonContainer>
            )}
          </div>
        </Styled.ControlsContentContainer>
      </Styled.ControlsContainer>
    </>
  );
};

export default Controls;
